import { CellType } from '../models';
import { TextCellParser } from './cell-parser/text-cell-parser';
import { ClickableCellParser } from './cell-parser/clickable-cell-parser';
import { CellParserBase } from './cell-parser/cell-parser-base';
import { Injectable } from '@angular/core';
import { StatusIconCellParser } from './cell-parser/statusicon-cell-parser';

@Injectable({ providedIn: 'root' })
export class CellParserFactoryService {
  constructor(
    private textCellParser: TextCellParser,
    private statusIconParser: StatusIconCellParser,
    private clickableCellParser: ClickableCellParser
  ) {}

  getParser(cellType: CellType): CellParserBase {
    switch (cellType) {
      case 'text':
        return this.textCellParser;
     case 'statusIcon':
          return this.statusIconParser;       
      case 'clickable':
        return this.clickableCellParser;
     case 'icon':
        return this.clickableCellParser;
      default:
        return this.textCellParser;
    }
  }
}
